import { render, staticRenderFns } from "./lowPriceDetailPreview.vue?vue&type=template&id=af8b4ca6&scoped=true"
import script from "./lowPriceDetailPreview.vue?vue&type=script&lang=js"
export * from "./lowPriceDetailPreview.vue?vue&type=script&lang=js"
import style0 from "./lowPriceDetailPreview.vue?vue&type=style&index=0&id=af8b4ca6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8b4ca6",
  null
  
)

export default component.exports